import { render, staticRenderFns } from "./EditMember.vue?vue&type=template&id=0fd45997&scoped=true&"
import script from "./EditMember.vue?vue&type=script&lang=js&"
export * from "./EditMember.vue?vue&type=script&lang=js&"
import style0 from "./EditMember.vue?vue&type=style&index=0&id=0fd45997&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd45997",
  null
  
)

export default component.exports